export default "__VITE_ASSET__CID3zUoS__"